//挂载svg路径
const reqContext = require.context('@/assets/icons', false, /\.svg$/)
reqContext.keys().map(reqContext)


// WEBPACK FOOTER //
// ./src/assets/icons/index.js